export default function RadioGroup({ options, selected, onSelect, name }) {
  return (
    <div className="radio-group" data-testid={`radio-group-${name}`}>
      {options.map((opt) => (
        <div
          key={opt.value}
          className={`radio-option ${selected === opt.value ? "selected" : ""}`}
          onClick={() => onSelect(opt.value)}
          data-testid={`radio-option-${name}-${opt.value}`}
          role="radio"
          aria-checked={selected === opt.value}
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelect(opt.value); } }}
        >
          <div className="radio-circle">
            <div className="inner" />
          </div>
          <div className="radio-label">{opt.label}</div>
        </div>
      ))}
    </div>
  );
}
